var App = App || {};

App.Toast = (function ($) {
    "use strict";

    function init() {
        onElementAppear('.toastify', () => {
            var closeBtn = $(".toastify").first().find("button");
            var prevFocus = $(":focus"); 

            closeBtn.focus();
            closeBtn.on('click', function () {
                if (prevFocus.length) {
                    prevFocus[0].focus();
                }
            });
        });
    }

    function onElementAppear(selector, callback) {
        const observer = new MutationObserver((mutations) => {
            if ($(selector).length) {
                callback();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Toast.init();
});